const qaIps = ['192.168.68.141', '192.168.68.147', '192.168.68.148'];
export const environment = {
  production: true,
  API_URL: qaIps.includes(window.location.hostname) ? `http://${window.location.hostname}:8443`  : 'https://tolis.backendapp.ftstecnologia.homelinux.com',
  API_URL_BACKEND_TOLIS: qaIps.includes(window.location.hostname) ? `http://${window.location.hostname}:8442` : 'https://tolis.backend.ftstecnologia.homelinux.com',
  siteKey: '6Lc3-vYqAAAAAHj1kOGZoBViXy1sB5jHYAcuX_Ea',
  NOTIFICACIONES_PUSH_SOCKET_URL: qaIps.includes(window.location.hostname) ? `http://${window.location.hostname}:3235/notificaciones-push` : 'https://tolis.ws.ftstecnologia.homelinux.com/notificaciones-push',
  idleTimeoutSeconds: 900, // 15 minutos
  timeoutWarningSeconds: 15,
};
